import { Text } from "@components/common/ui/Text";
import { styled } from "@styles";

export const DisclaimerText = styled(Text, {
  marginTop: "$8px",
  marginBottom: "$48px",
  width: "100%",
  maxWidth: "$1150px",
});
